import { useState } from 'react';
import { getFormattedCityNames, getFormattedCountryName } from '~/lib/helpers/constants'
import AddListingTwoStepModal from '../Modals/AddListingTwoStepModal';
import { OhButton } from '~/components/ui/custom-radix-components/button';

export default function PartnerWithOfficeHubDesktop({ region, isMobile }: { region?: string, isMobile?: boolean }) {
  const [addListingModal, setAddListingModal] = useState(false)
  return (
    <>

      {addListingModal && (
        <AddListingTwoStepModal onClose={() => setAddListingModal(false)} />
      )}
      <section className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

        <img
          src={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/partners.avif`}
          alt='A diverse team of professionals collaborating in a bright, modern breakout area provided by Office Hub'
          title='Office Hub Professionals'
          className='h-full w-full'
        />


        <div className="space-y-3">
          <h2 className="text-sm text-gray-500 uppercase font-semibold">Why List with Office Hub {getFormattedCountryName(region)}</h2>
          <p className="text-3xl font-bold text-gray-900">
            Join the world's leading marketplace for flexible offices.
          </p>
          <p className="text-gray-700 text-md">
            Office Hub {getFormattedCountryName(region)} connects coworking, serviced, and private office providers with thousands of verified tenants actively searching for workspace across {getFormattedCityNames(region)} and beyond.
          </p>
          <p className="text-gray-600">
            From flexible coworking desks to entire serviced floors, our {getFormattedCountryName(region)} team is here to help you find and secure the perfect space with ease. <b>Best of all our legendary service is totally free for tenants to find space.</b>
          </p>
          <div className="space-y-4 text-gray-700 text-base">
            <div>
              <h3 className="font-bold text-base">Free to List</h3>
              <p>Showcase your spaces at no cost. You only pay when a deal closes.</p>
            </div>
            <div>
              <h3 className="font-bold text-base">Qualified Leads</h3>
              <p>Every enquiry is verified by our workspace experts.</p>
            </div>
            <div>
              <h3 className="font-bold text-base">Analytics & Insights</h3>
              <p>Get data on views, engagement, and conversion rates.</p>
            </div>
            <div>
              <h3 className="font-bold text-base">Dedicated Support</h3>
              <p>Our team books your tours, qualifies prospects, and helps finalize deals.</p>
            </div>
            <div>
              <h3 className="font-bold text-base">Global Exposure</h3>
              <p>Your listings appear on Office Hub's international network across 110+ countries.</p>
            </div>
          </div>
          <OhButton onClick={() => setAddListingModal(true)} >
            Add Listing
          </OhButton>
        </div>
      </section>
    </>
  )
}
